import React from 'react';
import { Form } from 'semantic-ui-react';

import { Resultados } from 'src/api';

type CursoDTO = Readonly<Resultados<'listaDeCursos'>['cursos']>[number];

export type Props = Readonly<{
    label: string;
    cursos: readonly CursoDTO[];
    idCursoSeleccionado: number;
    alSeleccionarCurso: (idCurso: number) => void;
}>;

export class SelectDeCursos extends React.PureComponent<Props> {
    public render() {
        const { label, cursos, idCursoSeleccionado, alSeleccionarCurso } = this.props;

        return (
            <Form.Select
                label={label}
                required
                search
                noResultsMessage='No hay resultados.'
                deburr
                options={cursos.map(cur => ({
                    key: cur.id,
                    value: cur.id,
                    text: `${cur.nombre} ${formatearProfesor(cur.profesor)} ${DIAS[cur.dia]} ${
                        cur.bloqueHorario.horaInicio
                    }-${cur.bloqueHorario.horaTermino}`,
                    content: (
                        <>
                            {cur.nombre} {formatearProfesor(cur.profesor)}
                            &emsp;
                            {DIAS[cur.dia]} {cur.bloqueHorario.horaInicio}-
                            {cur.bloqueHorario.horaTermino}
                        </>
                    ),
                }))}
                value={idCursoSeleccionado}
                onChange={(_, { value }) => alSeleccionarCurso(Number(value))}
                width='6'
            />
        );
    }
}

const DIAS = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

function formatearProfesor(profesor: CursoDTO['profesor']) {
    if (!profesor) return '';
    const { primerNombre, apellidoPaterno } = profesor.nombre;
    return `(${primerNombre} ${apellidoPaterno[0]}.)`;
}



// WEBPACK FOOTER //
// ./src/componentes/SelectDeCursos/index.tsx